import { Helmet } from "react-helmet";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Box, Container, Grid } from "@material-ui/core";
import { fetctHostProfile } from "src/actions/EditHost";
import AccountProfile from "src/components/account/AccountProfile";
import AccountProfileDetails from "src/components/account/AccountProfileDetails";

const Account = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetctHostProfile());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <Helmet>
        <title>Tubayo Host | Account</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={3}>
            <Grid item lg={4} md={6} xs={12}>
              <AccountProfile />
            </Grid>
            <Grid item lg={8} md={6} xs={12}>
              <AccountProfileDetails />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Account;
